import { History, WorkspaceElement } from 'types';
import { RootGetters, State } from 'stores/type';
import { WORKSPACE_ID } from 'constants/drag';
import { StorageKey } from 'constants/storage';
import { StorageEntry } from './index';

type WorkspaceInactiveData = {
  workspaceFinal: RootGetters['workspaceFinal'],
  workspaceExhausted: RootGetters['workspaceExhausted'],
  exhausted: RootGetters['exhaustedVisible'],
};
type StatsData = {
  firstLaunch: number,
  sessionsCount: number,
};

const progress: StorageEntry<History, Array<[string, string, number]>> = {
  key: StorageKey.PROGRESS,
  parse: (data) => {
    const historyList = data.map(([father, mother, timestamp]) => ({
      father,
      mother,
      timestamp,
    }));

    return historyList;
  },
  prepare: ($store) => {
    const history = $store.getters.history;
    return history.map(({ father, mother, timestamp }) =>
      [father, mother, timestamp] as [string, string, number]);
  },
  watch: [],
};

const workspace: StorageEntry<WorkspaceElement[], WorkspaceElement[]> = {
  key: StorageKey.WORKSPACE,
  parse: (data) => data,
  prepare: ($store) => {
    if (!$store.getters.hasProgress) {
      return [];
    }

    // get elements in DOM order
    const domElements =
      document.querySelectorAll(`#${ WORKSPACE_ID } [data-id][data-normal]`) as NodeListOf<HTMLElement>;
    const elements: WorkspaceElement[] = [];
    Array.from(domElements).forEach(({ dataset: { id } }) => {
      if (id === $store.getters.draggableHelperId) return;

      elements.push($store.getters.droppableById(id as string));
    });

    return elements;
  },
  watch: [],
};

const workspaceInactive: StorageEntry<WorkspaceInactiveData, WorkspaceInactiveData> = {
  key: StorageKey.WORKSPACE_INACTIVE,
  parse: (data) => data,
  prepare: ($store) => ({
    workspaceFinal: $store.getters.workspaceFinal,
    workspaceExhausted: $store.getters.workspaceExhausted,
    exhausted: $store.getters.exhaustedVisible,
  }),
  watch: [],
};

const resetTimestamp: StorageEntry<number, number> = {
  key: StorageKey.RESET_TIMESTAMP,
  parse: (data) => data,
  prepare: ($store) => $store.getters.resetTimestamp,
  watch: [],
};

const settings: StorageEntry<State['settings'], State['settings']> = {
  key: StorageKey.SETTINGS,
  parse: (data) => data,
  prepare: ($store) => $store.state.settings,
  watch: [],
};

const encyclopedia: StorageEntry<State['encyclopedia'], State['encyclopedia']> = {
  key: StorageKey.ENCYCLOPEDIA,
  parse: (data) => data,
  prepare: ($store) => $store.state.encyclopedia,
  watch: [],
};

const stats: StorageEntry<StatsData, StatsData> = {
  key: StorageKey.STATS,
  parse: (data) => data,
  prepare: ($store) => ({
    firstLaunch: $store.getters.firstLaunch,
    sessionsCount: $store.getters.sessionsCount,
  }),
  watch: [],
};

type TutorialsStorage = Pick<State['tutorials'], 'shownText'>;
const tutorials: StorageEntry<TutorialsStorage, TutorialsStorage> = {
  key: StorageKey.TUTORIALS,
  parse: (data) => data,
  prepare: ($store) => ({
    shownText: $store.getters.tutorialTextShown,
  }),
  watch: [],
};

export default {
  [StorageKey.PROGRESS]: progress,
  [StorageKey.WORKSPACE]: workspace,
  [StorageKey.WORKSPACE_INACTIVE]: workspaceInactive,
  [StorageKey.RESET_TIMESTAMP]: resetTimestamp,
  [StorageKey.SETTINGS]: settings,
  [StorageKey.ENCYCLOPEDIA]: encyclopedia,
  [StorageKey.STATS]: stats,
  [StorageKey.TUTORIALS]: tutorials,
};
